<template>
  <div class="baseExpandSearchBox" :style="{paddingBottom:padBottom}">
    <el-form :inline="true" size='small' @submit.native.prevent>
      <el-form-item v-for="(item,index) in searchList" :key="index">
        <el-input :style="{width:(item.width?item.width:'220px')}" v-model.trim="searchParams[item.paramName]" clearable
          :placeholder="'请输入'+item.label" v-if="item.inputType == 'input'" :maxlength="item.maxNum?item.maxNum:20"
          autocomplete="off" @keyup.enter.native='onSearchClick' @input="watchInput">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <span class="unit" v-if="item.unit">{{item.unit}}</span>
        <el-select filterable :remote="item.remote" @change="changeSelect($event,item)" clearable
          v-model="searchParams[item.paramName]" :placeholder="'请选择'+ item.label" v-if="item.inputType == 'select'">
          <el-option v-for="el in item.optionData" :key="el.key?el.key:el.value" :label="el.label" :value="el.value">
          </el-option>
        </el-select>
        <el-date-picker v-if="item.inputType == 'datetimerange'" v-model="searchParams[item.paramName]"
          value-format="yyyy-MM-dd" :default-time="['00:00:00']" clearable align="center" popper-class="popper-class"
          type="daterange" range-separator="至" :start-placeholder="item.showLabel?item.label+'开始日期':'开始日期'"
          :end-placeholder="item.showLabel?item.label+'结束日期':'结束日期'">
        </el-date-picker>
        <el-date-picker v-if="item.inputType == 'datetimerangesing'" align="right"  value-format="yyyy-MM-dd" v-model="searchParams[item.paramName]" type="date" :placeholder="'请选择'+item.label">
        </el-date-picker>
        <selectHospital v-if="item.inputType == 'hospital'" :placeholder="'请选择'+ item.label"
          @getChooseHospitalId="getChooseHospitalId" ref="selectHospitalId"></selectHospital>
        <channelHospital v-if="item.inputType == 'channelId'" :hospital='channelId' :placeholder="'请选择'+ item.label"
          @getChooseHospitalId="getChannelHospitalId" ref="selectHospitalId"></channelHospital>
        <selectLabel v-if="item.inputType == 'label'"  :tabNamePartent='searchParams[item.paramName]' ref="selectLabel" :placeholder="'请选择'+ item.label"
          @getChooseLabel="getChooseLabel"></selectLabel>
        <selectLabelTag v-if="item.inputType == 'labelTag'" :tabNamePartent='searchParams[item.paramName]' ref="selectTag" :placeholder="'请选择'+ item.label"
          @getChooseLabel="getChooseTag"></selectLabelTag>
        <el-select filterable v-model="searchParams[item.paramName]" :placeholder="'请选择'+ item.label"
          v-if="item.inputType == 'selectDisease'">
          <el-option v-for="el in selectdiseaseList" :key="el.value" :label="el.label" :value="el.value">
          </el-option>
        </el-select>
        <el-select filterable multiple clearable v-model="searchParams[item.paramName]" :placeholder="'请选择'+ item.label"
          v-if="item.inputType == 'selectChannel'">
          <el-option v-for="el in item.optionData" :key="el.value" :label="el.label" :value="el.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="onResetClick">重置</el-button>
        <el-button type="primary" @click="onSearchClick">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-form :inline="true" :class="setRightWidth?'setRightWidth':''" size="small" v-if="rightEventList.length>0">
      <el-form-item>
        <el-button type="primary" v-for="(item,index) in rightEventList" :key='index' @click="rightFunc(item)">
          {{item.eventName}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { api_get_disease_type } from "@/api/ManagementPlan";
export default {
  components: {
    channelHospital: () =>
      import("@/components/selectHospital/channelIndex.vue"),
    selectLabelTag:()=> import("@/components/selectLabelTag/index.vue"),
  },
  props: {
    //使用可参考courseList.vue
    // *必填项
    searchList: {
      type: Array,
      default: () => [],
      require: true
    },
    padBottom: {
      type: String,
      default: "16px"
    },
    setRightWidth: {
      type: Boolean,
      default: false
    },
    // 保留从其他页面返回时已存在的搜索条件
    searchEnd: {
      type: Object,
      default: () => {},
      require: false
    },
    //右侧事件列表
    rightEventList: {
      type: Array,
      default: () => [],
      require: true
    }
  },
  data() {
    return {
      searchParams: {}, //传入字段
      selectdiseaseList: [], //主适配病种
      hospitalId: "",
      channelId: "",
      isHaveDefaul: false,
      diseaseFlag: false //是否需要获取适配病种数据
    };
  },
  watch: {
    searchList: {
      handler(val) {
        if (val.length) {
          for (let index = 0; index < val.length; index++) {
            if (val[index].default || val[index].default == "") {
              this.$set(
                this.searchParams,
                val[index].paramName,
                val[index].default
              );
              //注：如果存在默认搜索条件，这里触发列表接口，父组件页面中创建页面时无需触发列表接口，避免接口重复请求
              this.isHaveDefaul = true;
              // this.onSearchClick();
            }
            // 是否清空值某个值
            if (val[index].clearVal) {
              this.$set(this.searchParams, val[index].paramName, "");
            }
          }
        }
        if (this.isHaveDefaul) {
          this.onSearchClick();
        }
      },
      deep: true,
      // immediate: true
    },
    searchEnd: {
      //处理其他页面返回继续保留原来参数
      handler(obj) { 
        if (obj) {
          Object.keys(obj).forEach(key => {
            if (key != "current" && key != "size") {
              //处理时间类型数据回显
              if (key == "timeKey") {
                let timeArr = obj[key].split(",");
                let resKey = timeArr.slice(0, 1).join();
                this.searchParams[resKey] = [timeArr[1], timeArr[2]];
              } else {
                this.searchParams[key] = obj[key];
              }
            }
          });
          this.$forceUpdate();
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.searchList.map(item => {
      if (item.inputType == "selectDisease") {
        this.diseaseFlag = true;
      }
    });
    //如果存在默认搜索条件，这里触发列表接口，父组件页面中创建页面时无需触发列表接口，避免接口重复请求
    // if (this.isHaveDefaul) {
    //   this.onSearchClick();
    // }
    if (this.diseaseFlag) {
      this.getDisease();
    }
    // this.getDisease();
  },
  methods: {
    watchInput(val) {
      this.$forceUpdate();
    },
    getChooseHospitalId(val, name) {
      for (let index = 0; index < this.searchList.length; index++) {
        if (this.searchList[index].inputType == "hospital") {
          this.searchParams[this.searchList[index].paramName] = val;
          this.searchParams.hospitalName = name;
        }
      }
    },
    getChannelHospitalId(val, chinnelId, name) {
      for (let index = 0; index < this.searchList.length; index++) {
        if (this.searchList[index].inputType == "channelId") {
          this.searchParams[this.searchList[index].paramName] = val ? val : "";
          // this.searchParams.hospitalName = name;
          //处理缓存列表搜索条件回显问题
          this.channelId = this.searchEnd[this.searchList[index].paramName];
        }
      }
    },
    getChooseLabel(val) { 
      for (let index = 0; index < this.searchList.length; index++) {
        if (this.searchList[index].inputType == "label") { 
          this.searchParams[this.searchList[index].paramName] = val;
        }
      }  
    },
    getChooseTag(val){
      for (let index = 0; index < this.searchList.length; index++) {
        if (this.searchList[index].inputType == "labelTag") { 
          this.searchParams[this.searchList[index].paramName] = val;
        }
      }  
    },
    getDisease() {
      api_get_disease_type().then(res => {
        if (res.code == 0) {
          this.selectdiseaseList = res.data.map(item => {
            return {
              value: item.id,
              label: item.suborderName
            };
          });
        }
      });
    },
    //搜索
    onSearchClick() {
      Object.keys(this.searchParams).forEach(key => {
        this.searchList.map(item => {
          if (item.inputType == "datetimerange" && item.paramName == key) {
            // console.log(this.searchParams[key])
            if (this.searchParams[key] && this.searchParams[key].length) {
              //处理开始时间 isTime ：需要加 00:00:00 23:59:59
              this.searchParams[item.paramstartTime] = item.isTime
                ? this.searchParams[key][0] + ' ' + "00:00:00"
                : this.searchParams[key][0];
              //处理截至时间
              this.searchParams[item.paramEndTime] = item.isTime
                ? this.searchParams[key][1] + ' ' + "23:59:59"
                : this.searchParams[key][1];
              // this.searchParams.timeKey =
              //   item.stringTime +
              //   "," +
              //   this.searchParams[key][0] +
              //   "," +
              //   this.searchParams[key][1];
               delete this.searchParams[key];
            } else {
              this.searchParams[item.paramstartTime] = null;
              this.searchParams[item.paramEndTime] = null;
              this.searchParams.timeKey = null;
            }
          }
          if (item.inputType == "datetimerangesing" && item.paramName == key) {
            if (this.searchParams[key]) {
              //处理开始时间 isTime ：需要加 00:00:00 23:59:59
              this.searchParams[item.paramstartTime] = item.isTime
                ? this.searchParams[key] + " 00:00:00"
                : this.searchParams[key];
              
            } else {
              this.searchParams[item.paramstartTime] = null;
              this.searchParams.timeKey = null;
            }
          }
          // if(item.inputType == "selectChannel"){
          //   console.log(this.searchParams[key],'ssss')
          //   // this.searchParams[item.paramName] = this.searchParams[key].toString();
          //   this.searchParams[item.paramName] = this.searchParams[key];
          // }else{
          //   this.searchParams[item.paramName] = [];
          // }
        });
      });
      console.log("传给父组件的参数：", this.searchParams);
      this.$emit("getSearchObj", this.searchParams);
    },
    changeSelect(val, item) {
      if (item.upList) {
        this.onSearchClick();
      }
      this.$forceUpdate();
    },
    //重置
    onResetClick() {
      this.searchParams = this.$options.data().searchParams;
      this.searchList.map(item => {
        if (!item.resetDefault) {
          if (item.default || item.default == "") {
            // this.searchParams[item.paramName] = item.default;
            this.$set(this.searchParams, item.paramName, item.default);
          }
        }
      });
      this.searchParams.isReset = true;
      this.$emit("getSearchObj", this.searchParams);
      if (this.$refs.selectHospitalId) {
        this.$refs.selectHospitalId[0].resettingVal();
      }
      if (this.$refs.selectLabel) {
        this.$refs.selectLabel[0].resettingVal();
      }
      if (this.$refs.selectTag) {
        this.$refs.selectTag[0].resettingVal();
      }
      
    },
    rightFunc(item) {
      this.$emit("rightFunc", item);
    }
  }
};
</script>  
<style scoped lang="less">
.baseExpandSearchBox {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}
.unit {
  margin-left: 5px;
}
.searchTag {
  border-radius: 11px;
  margin-right: 15px;
}
.float-right {
  float: right;
}
/deep/.el-range-separator {
  width: 30px;
}
.setRightWidth {
  min-width: 280px;
}
.baseExpandSearchBox /deep/.el-range-editor--small .el-range-input {
  font-size: 12px;
}
</style>